export const getPathParams = (paramString: string) => {
  const params = {};
  if (!paramString) {
    return params;
  }

  const paramsArray = paramString.split('&');

  paramsArray.forEach(item => {
    const itemArray = item.split('=');
    // @ts-ignore
    params[itemArray[0]] = itemArray[1];
  });

  return params;
};

export const getPath = (hash: string) => {
  const cleanHash = hash.split('?')[0];
  return `${cleanHash.substr(1).startsWith('/') ? cleanHash.substr(1) : `/${cleanHash.substr(1)}`}`;
};
